/**
 * "Sale marked Won → Mark that follow-up as done?" (2026-10-07, Manak).
 * Shown after a web Convert-to-Sales-Order when the server's `followUpDue` is
 * set. Same look as the MarkWonDialog follow-up step. Keep it = nothing;
 * Mark done = POST follow-up-done. Either way `onDone` runs (the sale is saved).
 */
import { useState } from 'react';
import { markFollowUpDone, wonFollowUpPromptText } from './leadFollowUpsApi';

export interface FollowUpDue {
  leadImportId: string;
  name: string | null;
  followUpDate: string;
}

export function readFollowUpDue(body: any): FollowUpDue | null {
  const d = body?.followUpDue;
  if (!d || typeof d.leadImportId !== 'string' || !d.leadImportId || typeof d.followUpDate !== 'string') return null;
  return { leadImportId: d.leadImportId, name: d.name ?? null, followUpDate: d.followUpDate };
}

export function WonFollowUpPrompt({ due, onDone }: { due: FollowUpDue; onDone: () => void }) {
  const [busy, setBusy] = useState(false);
  const finish = async (markDone: boolean) => {
    if (markDone) {
      setBusy(true);
      try { await markFollowUpDone(due.leadImportId); } catch { /* the sale is saved; the row stays in Follow-ups */ }
    }
    onDone();
  };
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40">
      <div role="dialog" aria-label="Sale marked Won" className="w-full max-w-md rounded-xl bg-[var(--bg-surface,#fff)] p-5 shadow-xl">
        <h3 className="text-base font-semibold">Sale marked Won</h3>
        <p className="mt-2 text-sm">{wonFollowUpPromptText(due.name || 'This customer', due.followUpDate)}</p>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" className="rounded-lg border px-3 py-1.5 text-sm" disabled={busy} onClick={() => void finish(false)}>Keep it</button>
          <button type="button" className="rounded-lg bg-green-600 px-3 py-1.5 text-sm font-semibold text-white disabled:opacity-50" disabled={busy} onClick={() => void finish(true)}>Mark done</button>
        </div>
      </div>
    </div>
  );
}
